export const blogTranslations={
  blog_screen_title: "Quality Nexus مدونة",
  blog_screen_descrition: "رؤى وأفضل الممارسات واتجاهات الصناعة في اختبار البرمجيات وضمان الجودة",
  blog_search_bar: " ابحث عن المقالات أو المواضيع أو العلامات",
  blog_category: "إظهار جميع الفئات",
  show_less: "إظهار أقل",
  show_all_categories:"إظهار جميع الفئات",
  blog_read_more: "اقرأ المزيد",
  blog_showing_filtered: "يتم عرض {{count}} من أصل {{total}} مقالة في {{category}}{{search}}",
  blog_showing_all: "يتم عرض {{count}} من أصل {{total}} مقالة{{search}}",
  blog_search_term: " للبحث عن \"{{term}}\"",
  next:"التالي",
  previous:"السابق",
  no_blog_posts_found: "لا توجد منشورات مدونة تتطابق مع هذا الفلتر.",
  noArticles_title: "لم يتم العثور على مقالات",
  noArticles_description: "حاول تعديل كلمات البحث أو تصفح فئات مختلفة",
  noArticles_clearButton: "إزالة الفلاتر",
  blog_categories: {
    all: "الكل",
    backToBlog: "العودة إلى المدونة",
    browseByCategory: "تصفح حسب الفئة",
    introText: "ابحث عن مقالات تناسب اهتماماتك وخبراتك في الاختبار",
    searchPlaceholder: "ابحث عن المقالات أو المواضيع أو الوسوم...",
    categories: "الفئات",
    filterDescription: "تصفية المقالات حسب الموضوع",
    categoryFilterPlaceholder: "تصفية الفئات...",
  },
  newsletter: {
      title: "كن علي تواصل",
      description: "اشترك في نشرتنا البريدية للحصول على آخر التحديثات والفعاليات وأخبار المجتمع.",
      emailPlaceholder: "عنوان بريدك الإلكتروني",
      subscribe: "اشتراك"
    },
 };